var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 35",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.383 34.567 12.485-7.135a3.224 3.224 0 0 0 1.632-2.797v-14.27c0-1.154-.622-2.22-1.632-2.798L17.383.433a3.295 3.295 0 0 0-3.265 0L1.632 7.567A3.225 3.225 0 0 0 0 10.365v14.27c0 1.154.622 2.22 1.632 2.797l12.486 7.135a3.296 3.296 0 0 0 3.265 0Z",
    fill: "var(--send-message-button-primary-color)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.89 8.487 9.437 24.16c-.295.85.688 1.57 1.408 1.03l4.357-3.269a.912.912 0 0 1 1.094 0l4.358 3.268c.72.54 1.703-.179 1.408-1.029L16.612 8.487c-.284-.816-1.439-.816-1.723 0Z",
    fill: "var(--send-message-button-secondary-color)"
  })));
};
export default SvgSend;